import React from "react";
import Navbar from "./Navbar";
import { makeStyles } from "@material-ui/core/styles";
import {
  Box,
  Grid,
  Card,
  CardContent,
  Typography,
  Chip,
} from "@material-ui/core";

const useStyles = makeStyles(() => ({
  container: {
    background: "#121212",
    minHeight: "100vh",
    paddingTop: "80px",
    paddingBottom: "40px",
  },
  card: {
    maxWidth: 400,
    margin: "1.5rem auto",
    background: "#1d1f1e",
    borderRadius: 15,
    boxShadow: "0px 4px 12px rgba(0,0,0,0.4)",
    transition: "transform 0.3s ease, box-shadow 0.3s ease",
    "&:hover": {
      transform: "translateY(-6px)",
      boxShadow: "0px 6px 18px rgba(0, 255, 245, 0.4)",
    },
  },
  title: {
    textAlign: "center",
    color: "#00e0ff",
    fontSize: "2rem",
    fontWeight: 700,
    marginBottom: "1rem",
    textShadow: "0 0 10px #00e0ff",
  },
  chip: {
    background: "#00e0ff",
    color: "#000",
    fontWeight: 600,
    marginBottom: "10px",
  },
  text: {
    color: "#ccc",
    lineHeight: 1.6,
  },
}));

const Blogs = () => {
  const classes = useStyles();

  const blogData = [
    {
      title: "Mastering React Components",
      desc: "Deep dive into reusable components, hooks, and modern patterns.",
      status: "COMING SOON",
    },
    {
      title: "How I Built My Portfolio",
      desc: "The full journey of design, development, deployment, and UI decisions.",
      status: "COMING SOON",
    },
    {
      title: "From IT Support to Software Engineer",
      desc: "My personal roadmap, tips, mistakes, and what I learned.",
      status: "COMING SOON",
    },
    {
      title: "Best Practices in Modern JavaScript",
      desc: "Clean code, performance, readability, and ES6+ concepts.",
      status: "COMING SOON",
    },
  ];

  return (
    <>
      <Navbar />

      <Box className={classes.container}>
        <Typography className={classes.title}>
          <span role="img" aria-label="emoji">
            📝
          </span>
          Pukar’s Blog Zone
        </Typography>

        <Grid container spacing={3} justify="center">
          {blogData.map((blog, index) => (
            <Grid item xs={12} sm={6} md={4} key={index}>
              <Card className={classes.card}>
                <CardContent>
                  <Chip
                    label={blog.status}
                    size="small"
                    className={classes.chip}
                  />
                  <Typography
                    variant="h6"
                    style={{ color: "#fff", fontWeight: 600 }}
                  >
                    {blog.title}
                  </Typography>
                  <Typography
                    variant="body2"
                    className={classes.text}
                    style={{ marginTop: 10 }}
                  >
                    {blog.desc}
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Box>
    </>
  );
};

export default Blogs;
